import { createSelector } from '../../dependencies';

const selectModal = (state, id) => state.modals[id];
const selectModalPlaceholder = state => state.modals.placeholder;

export const modalSelector = createSelector(
    [selectModal, selectModalPlaceholder],
    (modal, placeholder) => modal || placeholder,
);
